import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SumNumber } from '../../../lib/helpers/ArrayHelper';
import { FilterToSendableItems } from './FilterToSendableItems';

export interface GroupSummary {
  totalOrders: number;
  totalQuantity: number;
  smartSendItemCount: number;
}

export function GenerateGroupSummary(items: SmartSendItemApiModel[]): GroupSummary {
  const oc = SumNumber(items.map((x) => x.MarketplaceOrderLines.filter(FilterToSendableItems).length));
  const qc = SumNumber(
    items.map((x) => SumNumber(x.MarketplaceOrderLines.filter(FilterToSendableItems).map((x) => Number(x.Quantity))))
  );
  const ic = items.filter((i) => i.MarketplaceOrderLines.filter(FilterToSendableItems).length > 0).length;

  return { totalOrders: oc, totalQuantity: qc, smartSendItemCount: ic };
}
